import { fetchEntities, fetchJson, Method, toRequestOptions } from './api';
import { APISolutionAttributes, APISolutionPreview } from '@ardoq/api-types';
import { ApiResponse } from './types';

const installSolution = async (
  useCaseId: string
): ApiResponse<APISolutionAttributes> => {
  const request = new Request(
    `/api/solution/install/${useCaseId}`,
    toRequestOptions(Method.POST, {})
  );
  return fetchJson(request);
};

const upgradeSolution = async (
  solutionId: string
): ApiResponse<APISolutionAttributes> => {
  const request = new Request(
    `/api/solution/upgrade/${solutionId}`,
    toRequestOptions(Method.POST, {})
  );
  return fetchJson(request);
};

const fetchPreview = async (
  solutionId: string
): ApiResponse<APISolutionPreview> => {
  const request = new Request(
    `/api/solution/preview/${solutionId}`,
    toRequestOptions(Method.GET, undefined)
  );
  return fetchJson(request);
};

export const solutionApi = {
  fetchAvailable: fetchEntities<APISolutionAttributes>('solution/available'),
  installSolution,
  upgradeSolution,
  fetchPreview,
};
